import owd from 'owd/owd';

export default class FontSize extends owd.Component {
	init() {
        this.fontSize =  Number(this.$element.data('font-size'));
        this.fontSizeCookie = Number(localStorage.getItem('fontSize')) || null;
        
		this.bind();
	}

    setFontSize(size) {
        const htmlFontSize = parseInt(this.dom.$html.css('font-size'), 10);
        
        /*if(window.matchMedia('(max-width: 1023px)').matches) {
            const diff = size - htmlFontSize;
            size = htmlFontSize - diff;
            
            this.dom.$html.css('font-size', `${size}px`);
        } else {
            this.dom.$html.css('font-size', `${size}px`);
        }*/
        if(window.matchMedia('(max-width: 1023px)').matches) {
            if(size === 9) {
                this.dom.$html.css('font-size', `${htmlFontSize - 1}px`);
            } else if(size === 10) {
                this.dom.$html.css('font-size', `${htmlFontSize}px`);
            } else {
                this.dom.$html.css('font-size', `${htmlFontSize + 1}px`);
            }
        } else {
            this.dom.$html.css('font-size', `${size}px`);
        }
    }
    
	bind() {
        
        this.on('click', (e) => {
            localStorage.setItem('fontSize', this.fontSize);
            this.setFontSize(this.fontSize);
        });
        
        this.on('domready ajaxload', this.dom.$window, (e) => {
            if(this.fontSize === this.fontSizeCookie) {
                this.setFontSize(this.fontSizeCookie);
            }
        });
        
    }

    destroy() {
        super.destroy();
    }
}

owd.registerComponent('font-size', {
	component: FontSize
});
